var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,_vm._g({tag:"component",class:[
    // Base class
    'v-text',

    // Add padding for word wrap if there is a tooltip
    { 'pr-3': !!_vm.tooltip },

    // Font-size classes
    !_vm.size && ("v-text--size-" + _vm.fontSize),
    !_vm.heading && _vm.size === 'small' && "v-text--size-2",
    !_vm.heading && _vm.size === 'medium' && "v-text--size-3",
    !_vm.heading && _vm.size === 'large' && "v-text--size-3 v-text--size-md-4",
    _vm.heading && _vm.size === 'xsmall' && "v-text--size-4 v-text--size-md-5",
    _vm.heading && _vm.size === 'small' && "v-text--size-5 v-text--size-md-6",
    _vm.heading && _vm.size === 'medium' && "v-text--size-6 v-text--size-md-7",
    _vm.heading && _vm.size === 'large' && "v-text--size-7 v-text--size-md-8",
    _vm.heading && _vm.size === 'xlarge' && "v-text--size-8 v-text--size-md-9",
    _vm.heading && _vm.size === 'frontpage' && "v-text--frontpage",
    !!_vm.fontMdSize && ("v-text--size-md-" + _vm.fontMdSize),
    !!_vm.fontLgSize && ("v-text--size-lg-" + _vm.fontLgSize),

    // Font weight and italic
    (_vm.bold || _vm.heading) && 'font-weight-bold',
    _vm.italic && 'font-italic',

    // Linebreaks
    _vm.linebreaks && 'v-text--linebreaks'
  ]},_vm.$listeners),[(_vm.id && ['h2', 'h3', 'h4'].includes(_vm.tag))?_c('v-anchor',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.animatedLists.length > 0)?_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({ active: true, callback: _vm.onWaypoint, options: _vm.intersectionOptions }),expression:"{ active: true, callback: onWaypoint, options: intersectionOptions }"}]}):_vm._e(),(_vm.truncateSlot)?_c('v-truncate',{attrs:{"middle":_vm.truncateMiddle}},[_vm._t("default")],2):_vm._t("default"),(_vm.tooltip)?_c('v-infoicon',{attrs:{"tooltip":_vm.tooltip,"offset":"0px"}}):_vm._e(),(_vm.tagName === 'a')?_c('v-icon',{staticClass:"v-text__icon--link",attrs:{"name":"link","size":"xxsmall"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }